import { render, staticRenderFns } from "./HeaderDocumentModal.vue?vue&type=template&id=6c11e46f&scoped=true&"
import script from "./HeaderDocumentModal.vue?vue&type=script&lang=js&"
export * from "./HeaderDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c11e46f",
  null
  
)

export default component.exports